// Source:
// https://stackoverflow.com/questions/56588625/react-show-material-ui-tooltip-only-for-text-that-has-ellipsis?rq=1
// Allows user to see full text by hovering over when overflow

import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { makeStyles } from '@material-ui/styles';
import { Typography, Tooltip } from '@material-ui/core';

const useStyles = makeStyles((theme) => styles(theme));

const propTypes = {
    className: PropTypes.string,
    classes: PropTypes.object, // When swapped to Typescript can pull TypographyProps from MaterialUI directly
    tooltip: PropTypes.node,
    children: PropTypes.node.isRequired
};

const defaultProps = {
    className: undefined,
    classes: {},
    tooltip: undefined
};

function OverflowTypography ({ className, classes, tooltip, children, ...otherProps }) {
    const overflowTypographyClasses = useStyles();
    const textElementRef = useRef();
    const [isOverflowed, setIsOverflowed] = useState(false);
    const { root, ...otherClasses } = classes;

    //  TODO - Should update whenever the element changes size, not just on mount
    useEffect(() => {
        setIsOverflowed(textElementRef.current.scrollWidth > textElementRef.current.clientWidth);
    }, []);

    return (
        <Tooltip
            title={tooltip || children}
            disableHoverListener={!isOverflowed}
            interactive
        >
            <Typography
                ref={textElementRef}
                classes={{
                    root: classnames(overflowTypographyClasses.overflow, root, className),
                    ...otherClasses
                }}
                {...otherProps}
            >
                {children}
            </Typography>
        </Tooltip>
    );
}

const styles = theme => ({
    overflow: {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
    }
});

OverflowTypography.propTypes = propTypes;
OverflowTypography.defaultProps = defaultProps;

export default OverflowTypography;